import axiosInstance from "./axios-config";

export interface LinkExistingUserRequest {
  email: string;
  phone: string;
  vigilaneId: number;
}

export interface CreateNewUserRequest {
  email: string;
  vigilaneId: number;
}

export interface VigilaneUserResponse {
  id: number;
  email: string;
  phone?: string;
  fullname?: string;
  hasVigilane: boolean;
  vigilaneId: number;
}

export interface VigilaneApiResponse {
  success: boolean;
  message: string;
  data: {
    user: VigilaneUserResponse;
    emailSent?: boolean;
    message?: string;
  };
}

/**
 * Lier un utilisateur Safee existant à Vigilane
 */
export const linkExistingUser = async (
  data: LinkExistingUserRequest
): Promise<VigilaneApiResponse> => {
  const response = await axiosInstance.post<VigilaneApiResponse>(
    "/vigilane/link-existing",
    data
  );
  return response.data;
};

/**
 * Créer un nouvel utilisateur Safee avec liaison Vigilane
 */
export const createNewUserWithVigilane = async (
  data: CreateNewUserRequest
): Promise<VigilaneApiResponse> => {
  const response = await axiosInstance.post<VigilaneApiResponse>(
    "/vigilane/create-with-link",
    data
  );
  return response.data;
};

export interface VigilaneStatus {
  hasVigilane: boolean;
  vigilaneId: number | null;
  connectionStatus: 'connected' | 'disconnected' | 'unknown';
  lastTestedAt?: string;
  mainEndpointReachable?: boolean;
  backupEndpointReachable?: boolean;
  responseTime?: number;
}

export interface VigilaneStatusResponse {
  success: boolean;
  data: VigilaneStatus;
}

/**
 * Récupérer le statut de connexion Vigilane pour un utilisateur
 */
export const getVigilaneStatus = async (
  userId: number
): Promise<VigilaneStatus> => {
  const response = await axiosInstance.get<VigilaneStatusResponse>(
    `/vigilane/status/${userId}`
  );
  return response.data.data;
};
